(() => {
  'use strict';
  if (window.homaCleanCartBound) return;
  window.homaCleanCartBound = true;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  const base = window.Shopify?.routes?.root || '/';
  let busy = false;
  function sync() {
    drawer.classList.toggle('is-empty', !!drawer.querySelector('.drawer__inner-empty'));
    const count = Number(drawer.querySelector('[data-hcc-count]')?.dataset.hccCount || 0);
    document.querySelectorAll('.tsh-count,.glh-count,[data-cart-count],.cart-count-bubble span[aria-hidden="true"]').forEach(el => {
      if (el.textContent !== String(count)) el.textContent = count;
    });
  }
  async function request(path, body) {
    const response = await fetch(base + path, body ? {
      method: 'POST', headers: {'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify(body)
    } : {headers:{Accept:'application/json'},cache:'no-store'});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw Error(data.description || 'Impossible de modifier le panier. Réessayez.');
    return data;
  }
  async function refresh(sections) {
    if (!sections?.['cart-drawer']) sections = await request('?sections=cart-drawer');
    const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const next = parsed.querySelector('cart-drawer');
    if (!next) throw Error('Impossible d’actualiser le panier. Rechargez la page.');
    drawer.innerHTML = next.innerHTML;
    sync();
    (drawer.querySelector('.drawer__close') || drawer.querySelector('[role="dialog"]'))?.focus();
  }
  async function mutate(path, body, source) {
    if (busy) return;
    busy = true;
    drawer.dataset.hccBusy = 'true';
    const buttons = [...drawer.querySelectorAll('button,input')];
    buttons.forEach(el => el.disabled = true);
    const error = drawer.querySelector('.hcc-error');
    if (error) error.hidden = true;
    try {
      const data = await request(path, {...body,sections:['cart-drawer'],sections_url:location.pathname});
      await refresh(data.sections);
    } catch (e) {
      if (error) { error.textContent = e.message; error.hidden = false; }
      if (source?.matches('[data-hcc-warranty]')) source.checked = !source.checked;
    } finally {
      busy = false;
      delete drawer.dataset.hccBusy;
      buttons.forEach(el => el.disabled = false);
    }
  }
  document.addEventListener('click', event => {
    const quantity = event.target.closest('[data-hcc-quantity]');
    const add = event.target.closest('[data-hcc-add]');
    if (quantity) {
      event.preventDefault();
      mutate('cart/change.js', {id:quantity.closest('[data-hcc-item]').dataset.key,quantity:Number(quantity.dataset.hccQuantity)}, quantity);
    } else if (add) {
      event.preventDefault();
      mutate('cart/add.js', {items:[{id:Number(add.dataset.hccAdd),quantity:Number(add.dataset.quantity || 1)}]}, add);
    } else if (event.target.closest('.cart-drawer__overlay')) {
      drawer.close?.();
    }
  });
  document.addEventListener('change', event => {
    const toggle = event.target.closest('[data-hcc-warranty]');
    if (!toggle) return;
    if (toggle.checked) mutate('cart/add.js',{items:[{id:Number(toggle.dataset.hccWarranty),quantity:1}]},toggle);
    else mutate('cart/change.js',{id:toggle.dataset.key,quantity:0},toggle);
  });
  new MutationObserver(sync).observe(drawer,{childList:true,subtree:true});
  sync();
})();
